import { jsxs as e, jsx as l } from "react/jsx-runtime";
import { DEFAULT_METRIC_ICON_SIZE as i } from "./index.es2359.js";
function t({ size: C = i }) {
  return /* @__PURE__ */ e(
    "svg",
    {
      width: C,
      height: C,
      viewBox: "0 0 56 57",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ l("rect", { y: "0.936646", width: "56", height: "56", rx: "3", fill: "#F3F3FD" }),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.4388 20.1033H24.7335V23.2726C24.7335 25.2179 23.1415 26.8099 21.1948 26.8099H20.9761C19.0308 26.8099 17.4388 25.2179 17.4388 23.2726V20.1033Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M19.2225 17.4366H24.7331V20.1033H17.4385V19.2193C17.4385 18.2353 18.2371 17.4366 19.2225 17.4366Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M25.6718 30.8138V34.0804L21.8611 40.4364H20.3264L16.4998 34.0804V30.8138C16.4998 29.3418 17.6944 28.1471 19.1664 28.1471H23.0051C24.4784 28.1471 25.6718 29.3418 25.6718 30.8138Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M20.3888 23.6805C20.2901 23.4226 20.0011 23.2935 19.7432 23.3921C19.4852 23.4908 19.3561 23.7798 19.4548 24.0377C19.7054 24.6931 20.3372 25.1645 21.0858 25.1645C21.836 25.1645 22.4663 24.6928 22.7168 24.0377C22.8154 23.7798 22.6863 23.4908 22.4284 23.3921C22.1704 23.2935 21.8814 23.4226 21.7828 23.6805C21.6733 23.9668 21.4022 24.1645 21.0858 24.1645C20.7703 24.1645 20.4981 23.9665 20.3888 23.6805Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.9385 19.2193C16.9385 17.9589 17.9612 16.9366 19.2225 16.9366H25.2331L25.2334 23.2727C25.2334 25.4943 23.4174 27.3101 21.1947 27.3101H20.9761C18.7546 27.3101 16.9387 25.4942 16.9387 23.2727L16.9385 19.2193ZM19.2225 17.9366C18.513 17.9366 17.9385 18.5117 17.9385 19.2193V19.6033H24.2331V17.9366H19.2225ZM17.9387 23.2727V20.6034H24.2334V23.2727C24.2334 24.9418 22.8654 26.3101 21.1947 26.3101H20.9761C19.3069 26.3101 17.9387 24.9419 17.9387 23.2727Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M35.8029 19.5521L39.9284 23.6776L35.8029 27.8045L35.0957 27.0975L38.0138 24.1783H29.312V23.1783H38.0149L35.0958 20.2592L35.8029 19.5521Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M34.1049 31.7171L33.3976 31.0101L29.2722 35.137L33.3977 39.2625L34.1048 38.5554L31.186 35.6366H39.8886V34.6366H31.1864L34.1049 31.7171Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.9998 30.8138C15.9998 29.0656 17.4183 27.6471 19.1664 27.6471H23.0051C24.7547 27.6471 26.1718 29.0658 26.1718 30.8138V34.0804C26.1718 34.171 26.1472 34.2599 26.1006 34.3375L22.2899 40.6935C22.1996 40.8442 22.0368 40.9364 21.8611 40.9364H20.3264C20.1511 40.9364 19.9885 40.8446 19.8981 40.6943L16.0714 34.3383C16.0245 34.2605 15.9998 34.1713 15.9998 34.0804V30.8138ZM19.1664 28.6471C17.9706 28.6471 16.9998 29.6179 16.9998 30.8138V33.9415L18.25 36.0182V32.0304C18.25 31.7543 18.4739 31.5304 18.75 31.5304C19.0261 31.5304 19.25 31.7543 19.25 32.0304V37.6451C19.25 37.6559 19.2497 37.6667 19.249 37.6774L20.609 39.9364H21.5779L22.925 37.6894C22.9238 37.6748 22.9231 37.66 22.9231 37.6451V32.0304C22.9231 31.7543 23.147 31.5304 23.4231 31.5304C23.6992 31.5304 23.9231 31.7543 23.9231 32.0304V36.0247L25.1718 33.942V30.8138C25.1718 29.6177 24.2021 28.6471 23.0051 28.6471H19.1664Z",
            fill: "#5E63E5"
          }
        )
      ]
    }
  );
}
t.__tags = [];
export {
  t as MetricCoTenantsIcon
};
//# sourceMappingURL=index.es385.js.map
